import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchReportData
} from "../../features/commonSlice/commonSlice";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { toast } from "react-toastify";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";
import { format } from "date-fns";
import Select from "react-select";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { formatDate } from "../../utils/dateUtils";
import CryptoJS from "crypto-js";
import moment from "moment";
import Filter from "../filter/Filter";
import Breadcrumbs from './../../Breadcrumbs';

export const headerData = {
  sr_no: "SR No.",
  action: "Client Name",
  video_id: "Video Id",
  video_url: "Video Url",
  platform: "Platform",
  channel_name: "Channel Name",
  channel_link: "Channel Link",
  genre: "Genre",
  language: "Language",
  subscribers: "Subscribers",
  deal_type: "Deal Type",
  live_date: "Live Date",
  live_time: "Live Time",
  snmb: "SMB/SNMB",
  product: "Product",
  video_status: "Video Status",
  description_url: "Description URL",
  views: "Views",
  likes: "Likes",
  comments: "Comments",
  clicks: "Clicks"
};

const AllInfluencer = () => {
  const dispatch = useDispatch();
  const decodeToken = useDecodedToken();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    channel_name: [],
    categories: [],
    languages: [],
    budget: { min: "", max: "" },
    subscribers: { min: "", max: "" },
    views: { min: "", max: "" }
  });
  const { reportListData, status } = useSelector((state) => state.influencer);
  const [clientsData, setClientsData] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
const [clientsPerPage, setClientsPerPage] = useState(10);
  const [errorData, setErrorData] = useState([]);

  useEffect(() => {
    dispatch(
      fetchReportData()
    );
  }, [dispatch]);

  useEffect(() => {
    
      setClientsData(reportListData?.data || []);
    
  }, [ reportListData ]);

  
  
  
  
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Video Planning</h4>

            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id="leadsList">
            <div className="card-header border-0">
              <div className="row g-4 align-items-center">
                
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    {/* <button
                      type="button"
                      className="btn btn-sm btn-info"
                      onClick={() => setShowFiltersDrawer(true)}
                    >
                      <i className="ri-filter-3-line align-bottom me-1"></i>{" "}
                      Filters
                    </button> */}
                    {/* <Button
                      className="btn btn-sm btn-success add-btn"
                      onClick={clickAddNew}
                    >
                      <i className="ri-add-line align-bottom me-1"></i> Add
                      Influencer
                    </Button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div style={{ overflowX: 'auto' }}>
              <table
                id="example"
                className="table table-bordered nowrap table-striped align-middle"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>{headerData.sr_no}</th>
                    <th>{headerData.action}</th>
                    <th>{headerData.video_id}</th>
                    <th>{headerData.platform}</th>
                    <th>{headerData.channel_link}</th>
                    <th>{headerData.genre}</th>
                    <th>{headerData.language}</th>
                    <th>{headerData.subscribers}</th>
                    <th>{headerData.deal_type}</th>
                    <th>{headerData.live_date}</th>
                    <th>{headerData.live_time}</th>
                    <th>{headerData.snmb}</th>
                    <th>{headerData.product}</th>
                    <th>{headerData.video_status}</th>
                    <th>{headerData.channel_name}</th>
                    <th>{headerData.video_url}</th>
                    <th>{headerData.description_url}</th>
                    <th>{headerData.views}</th>
                    <th>{headerData.likes}</th>
                    <th>{headerData.comments}</th>
                    <th>{headerData.clicks}</th>
                  </tr>
                </thead>
                <tbody>
                  {clientsData.length > 0 ? (
                    clientsData.map((dataActive, index) => (
                      <tr key={dataActive.id}>
                        <td>{(currentPage - 1) * clientsPerPage + index + 1}</td>
                        <td>{dataActive.client_name}</td>
                        <td>{dataActive.show_video_id}</td>        
                        <td>{dataActive.platform_name}</td>        
                        <td>{dataActive.channel_link}</td>
                        <td>{dataActive.genre_name}</td>
                        <td>{dataActive.language_name}</td>
                        <td>{dataActive.subscribers}</td>
                        <td>{dataActive.deal_type_name}</td>
                        <td>{formatDate(dataActive.live_date)}</td>
                        <td>{dataActive.live_time}</td>
                        <td>{dataActive.smb_snmb_name}</td>
                        <td>{dataActive.product_name}</td>
                        <td>{dataActive.video_status_name}</td>
                        <td>{dataActive.channel_name}</td>
                        <td>{dataActive.video_url}</td>
                        <td>{dataActive.description_url}</td>
                        <td>{dataActive.views}</td>
                        <td>{dataActive.likes}</td>
                        <td>{dataActive.comments}</td>
                        <td>{dataActive.clicks}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="21" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default AllInfluencer;
